// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"bb0864c4","525":"e4a0f15f"}[chunkId] + ".chunk.css";
};